module.exports = __webpack_public_path__ + "img/1.bbc3a858.png";